"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var GenericButton = function (props) {
    var children = props.children, _a = props.fullWidth, fullWidth = _a === void 0 ? false : _a, _b = props.size, size = _b === void 0 ? 'medium' : _b, _c = props.icon, icon = _c === void 0 ? false : _c, _d = props.disabled, disabled = _d === void 0 ? false : _d, vendorStyle = props.vendorStyle, inputMode = props.inputMode, // фикс непонятной ошибки styled components
    btnProps = __rest(props, ["children", "fullWidth", "size", "icon", "disabled", "vendorStyle", "inputMode"]);
    return (react_1.default.createElement(StyledButton, __assign({ "$isDisabled": disabled, "$isIcon": icon, "$fullWidth": fullWidth, "$size": size, disabled: disabled, "$vendorStyle": vendorStyle }, btnProps), children));
};
var StyledButton = styled_components_1.default.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-size: ", ";\n  background: ", ";\n  color: white;\n  text-transform: none;\n  border-radius: 6px;\n  padding: 10px 24px;\n  white-space: nowrap;\n  border: none;\n  ", "\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n"], ["\n  font-size: ", ";\n  background: ", ";\n  color: white;\n  text-transform: none;\n  border-radius: 6px;\n  padding: 10px 24px;\n  white-space: nowrap;\n  border: none;\n  ", "\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n"])), function (p) { return p.theme.fontSize.base; }, function (p) { return p.theme.colors.brand; }, function (p) {
    return p.$size === 'large' &&
        "\n      font-size: ".concat(p.theme.fontSize.large, ";\n      padding: 16px 32px;\n  ");
}, function (p) { return p.$fullWidth && 'width: 100%;'; }, function (p) {
    return p.$isIcon &&
        "\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      width: 44px;\n      height: 44px;\n      padding: 0px;\n      border-radius: 50%;\n      background: transparent;\n      transition: background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n      color: #3f4547;\n\n      &:hover {\n        background-color: rgba(0, 0, 0, 0.08);\n      }\n\n      svg {\n        fill: currentColor;\n      }\n  ";
}, function (p) {
    return p.$isDisabled &&
        "\n    cursor: not-allowed !important;\n    background-color: #f5f6f6;\n    color: rgba(0, 0, 0, 0.26);\n  ";
}, function (p) {
    return p.$vendorStyle === 'vtb' &&
        "\n    background-color: #002882 !important;\n    color: white;\n    border-radius: 4px;\n    &:hover {\n      background-color: #002882 !important;\n    }\n    ";
}, function (p) {
    return p.$vendorStyle === 'vtb-transparent' &&
        "\n    color: #002882 !important;\n    background-color: transparent !important;\n    border-radius: 4px;\n  ";
}, function (p) {
    return p.$vendorStyle === 'vtb-light' &&
        "\n    background-color: #00aaff !important;\n    color: white !important;\n    border-radius: 4px;\n    &:hover {\n      background-color: ##00aaff !important;\n    }\n  ";
});
exports.default = GenericButton;
var templateObject_1;
